import type { z } from 'zod'
import { MenuCategoryUpdate } from '~/services/api/contracts/requests/MenuCategoryUpdate'
import type { NoContext } from '~/services/api/contracts/NoContext'
import type { MenuCategoryUpdateForPartnerRequestSchema } from '~/services/api/generated'

// Mirrors UpdateMenuCategoryRequest, shared with MenuCategoryUpdate.
export const MenuCategoryUpdateForPartner = (
  context: NoContext
): z.ZodType<z.output<typeof MenuCategoryUpdateForPartnerRequestSchema>> =>
  MenuCategoryUpdate(context)
